import { render, staticRenderFns } from "./SideMenu.vue?vue&type=template&id=5abac2fa&scoped=true"
import script from "./SideMenu.vue?vue&type=script&lang=js"
export * from "./SideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abac2fa",
  null
  
)

export default component.exports